// extracted by mini-css-extract-plugin
export default {"header":"header__2clhK","header-badge":"header-badge__vnKNG"};